// Utility to reverse geocode lat/lng to city and state via backend /api/geocode
export async function getCityStateFromLatLng(
  lat: number,
  lng: number
): Promise<{ city: string; state: string; country?: string }> {
  const fallback = {
    city: "Not detected",
    state: "Not detected",
    country: undefined,
  };

  try {
    const res = await fetch(`/api/geocode?latlng=${lat},${lng}`);
    if (!res.ok) return fallback;

    const data = await res.json();
    if (data && data.success) {
      return {
        city: data.city || "Not detected",
        state: data.state || "Not detected",
        country: data.country,
      };
    }
    return fallback;
  } catch {
    return fallback;
  }
}


// Utility to get browser geolocation as a Promise
export function getBrowserLocation(options?: PositionOptions): Promise<{ lat: number; lng: number }> {
  return new Promise((resolve, reject) => {
    // Check if URL contains utm_campaign=downloadapp, if so, reject immediately to prevent browser permission popup
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const utmCampaign = urlParams.get('utm_campaign');
      if (utmCampaign === 'downloadapp') {
        reject(new Error('Geolocation disabled for downloadapp campaign'));
        return;
      }
    }

    if (!navigator.geolocation) {
      reject(new Error('Geolocation not supported'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        console.log('Latitude:', position.coords.latitude, 'Longitude:', position.coords.longitude);
        resolve({ lat: position.coords.latitude, lng: position.coords.longitude });
      },
      (error) => {
        reject(error);
      },
      options
    );
  });
} 